import { SharedKPIWidget } from '../shared/kpi/SharedKPIWidget';
import { WidgetConfig } from '../../infrastructure/contracts/widget.contract';
import { useAdminLeadsThisWeekAdapter } from './adapters/adminKpiAdapters';

export const adminLeadsThisWeekConfig: WidgetConfig = {
  id: 'admin-leads-week',
  title: 'This Week',
  icon: 'calendar_view_week',
  category: 'statistics',
  description: 'Number of leads added this week',
  refreshStrategy: 'interval',
  defaultSize: { w: 2, h: 1 },
  priority: 3,
  supportedRoles: ['admin', 'superadmin'],
};

export function AdminLeadsThisWeekWidget() {
  const dataQuery = useAdminLeadsThisWeekAdapter();

  return (
    <SharedKPIWidget
      config={adminLeadsThisWeekConfig}
      dataQuery={dataQuery}
      color="info"
    />
  );
}
